export const INFORMES_IMPRIMIR_START = 'INFORMES_IMPRIMIR_START';
export const INFORMES_IMPRIMIR_END = 'INFORMES_IMPRIMIR_END';
